import { useGeoHint } from "./useCars";

const US_LOCATION_RE = /\b(usa|united\s*states|u\.?s\.?a?\.?)\b/i;

/**
 * Detect "US intent" for the staged DRIVESHARE redirect.
 *
 * Returns true when either:
 *   - the IP-derived geo hint says the visitor is in the US, OR
 *   - the optional `searchLocation` text resolves as a US query
 *     (free-text contains "USA"/"United States", or matches a US state name).
 *
 * Backed by the shared `useGeoHint()` hook so HomePage, RegionSuggestionBanner
 * and search pages all hit `/api/geo/hint` at most once per session via the
 * react-query cache. The hook is a no-op until `enabled`, so callers should
 * gate it behind their feature flag check rather than always paying for the
 * fetch.
 */
export function useUsRedirectIntent(enabled: boolean, searchLocation?: string | null): boolean {
  const { data: geoHint } = useGeoHint({ enabled });
  const geoIsUs = (geoHint?.country || "").toUpperCase() === "US";

  if (!enabled) return false;
  if (geoIsUs) return true;
  if (searchLocation && US_LOCATION_RE.test(searchLocation)) return true;
  return false;
}
